import React, { useEffect, useState } from "react";
import { listProducts } from "@/lib/adapters/products";
import ProductCard from "@/components/product/ProductCard";
import { SectionHeading } from "./WhatBringsYouHere";

export default function OffersOfDay() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const primary = await listProducts({ type: "offer", limit: 12 });
        let rows = primary.items || [];
        if (rows.length < 6) {
          const fill = await listProducts({ type: "bulk", limit: 12 });
          const seen = new Set(rows.map((r) => r.id));
          for (const p of fill.items || []) {
            if (rows.length >= 6) break;
            if (!seen.has(p.id)) {
              rows.push(p);
              seen.add(p.id);
            }
          }
        }
        if (!cancelled) setItems(rows.slice(0, 6));
      } catch {
        if (!cancelled) setItems([]);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <section className="dyntra-container mt-10">
      <SectionHeading title="Offers of the Day" href="/offers" testid="offers-heading" />
      <div className="mt-6 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
        {items.slice(0, 6).map((p) => <ProductCard key={p.id} product={p} />)}
      </div>
    </section>
  );
}
